import moment from "moment";

export const getCookie = (name) => {
	if (!(typeof name === "string" || name instanceof String))
		throw new TypeError("Argument 1 must be a string");

	const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
	if (match) return match[2];
};

export const replaceCookie = (name) => {
	const currentPathArray = window.location.pathname.split("/");
	const filteredPathArray = currentPathArray.filter((item) => item);

	const cookiePath = `${filteredPathArray[0]}/${filteredPathArray[1]}`;
	const currentCookieValue = getCookie(name);
	document.cookie =
		name +
		"=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/" +
		cookiePath +
		";";
	const newCookieValue = getCookie(name);
	if (!newCookieValue) {
		document.cookie = `${name}=${currentCookieValue};path=/"`;
		return;
	}
	document.cookie = `${name}=${newCookieValue};path=/"`;
};

export const formatDateForRequest = (dateStr) => {
	if (!(typeof dateStr === "string" || dateStr instanceof String))
		throw new TypeError("Argument 1 must be a string");
	// dateStr should be of format DD/MM/yyyy, just like we have in the URL hash; no need to make this func super smart
	try {
		if (!dateStr) return "";
		const [day, month, year] = dateStr.split("/");
		return `${year}-${month}-${day}`;
	} catch (err) {
		console.error(err);
		return dateStr;
	}
};

export const formatDateForHash = (dateStr) => {
	if (!(typeof dateStr === "string" || dateStr instanceof String))
		throw new TypeError("Argument 1 must be a string");
	// dateStr should be of format yyyy-MM-DD, just like we receive in API responses; no need to make this func super smart
	try {
		if (!dateStr) return "";
		const [year, month, day] = dateStr.split("-");
		return `${day}/${month}/${year}`;
	} catch (err) {
		console.error(err);
		return dateStr;
	}
};

export const getDeepCopy = (obj) => {
	if (!obj) return;
	if (!(obj instanceof Object))
		throw new TypeError("Argument 1 must be an Object");
	return JSON.parse(JSON.stringify(obj));
};

export const getHashObj = (hashStr) => {
	if (!(typeof hashStr === "string" || hashStr instanceof String))
		throw new TypeError("Argument 1 must be a string");

	const hashObj = {};
	if (hashStr) {
		const keyValuePairs = hashStr.replace("#", "").split("&");
		keyValuePairs.forEach((pair) => {
			const [key, value] = pair.split("=");
			hashObj[key] = value;
		});
	}
	return hashObj;
};

export const setHash = (newEntries) => {
	if (!(newEntries instanceof Object))
		throw new TypeError("Argument 1 must be an Object");
	const hash = window.location.hash.replace("#", "");

	const existingHashObj = getHashObj(hash);

	const newHash = { ...existingHashObj, ...newEntries };

	let pairs = [];
	Object.entries(newHash).forEach(([key, value]) => {
		pairs.push(`${key}=${value}`);
	});
	window.location.hash = `#${pairs.join("&")}`;
};

export const elementInViewport = (element) => {
	if (!element) throw new Error("element cannot be undefined");

	let x = element.getBoundingClientRect().left;
	let y = element.getBoundingClientRect().top;
	let ww = Math.max(
		document.documentElement.clientWidth,
		window.innerWidth || 0
	);
	let hw = Math.max(
		document.documentElement.clientHeight,
		window.innerHeight || 0
	);
	let w = element.clientWidth;
	let h = element.clientHeight;
	return y < hw && y + h > 0 && x < ww && x + w > 0;
};

export const getSetIntersection = (setA, setB) => {
	if (!(setA instanceof Set) || !(setB instanceof Set))
		throw new TypeError("setA and setB must be of type Set");
	let _intersection = new Set();
	for (let elem of setB) {
		if (setA.has(elem)) {
			_intersection.add(elem);
		}
	}
	return _intersection;
};

export function fadeOut(el) {
	if (!(el instanceof Element))
		throw new TypeError("Argument 1 must be an Element");

	el.style.opacity = 1;
	(function fade() {
		if ((el.style.opacity -= 0.1) < 0) {
			el.style.display = "none";
		} else {
			requestAnimationFrame(fade);
		}
	})();
}

export function fadeIn(el, display) {
	if (!(el instanceof Element))
		throw new TypeError("Argument 1 must be an Element");

	el.style.opacity = 0;
	el.style.display = display || "block";
	(function fade() {
		var val = parseFloat(el.style.opacity);
		if (!((val += 0.1) > 1)) {
			el.style.opacity = val;
			requestAnimationFrame(fade);
		}
	})();
}

export function stringIsValidDate(str) {
	const regexExp =
		/(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/gi;
	return regexExp.test(str);
}

export const getCompanyCookie = () => {
	return getCookie("company");
};

const getAge = (date) => {
	const dateString = date.split("-").reverse().join("-");
	const today = new Date();
	const birthDate = new Date(dateString);
	let age = today.getFullYear() - birthDate.getFullYear();
	const month = today.getMonth() - birthDate.getMonth();
	if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
		age--;
	}

	// If the age is less then 1, return 1
	return age > 0 ? age : 1;
};

export const getParticipantAges = () => {
	const companyDataCookie = getCookie("companyData");

	if (!companyDataCookie) return;
	const participants = JSON.parse(companyDataCookie);
	if (!participants) {
		return [];
	}
	const participantsAges = [18];
	if (participants.conjoint && participants.conjoint?.isSelected) {
		participantsAges.push(18);
	}
	if (participants.enfants) {
		participants.enfants.forEach(function (child) {
			if (!child.isSelected) {
				return;
			}
			let age = getAge(child.dateNaissance);

			//if age over 18 I push in the age cookie a value of 18, as planning doesnt get value over 18 (either kids, under 18 or adult 18)
			if (age > 18) {
				age = 18;
			}
			participantsAges.push(age);
		});
	}

	return participantsAges;
};

export const getParticipantAgesFromSE = () => {
	const participantsAgesFromCookie = getCookie("participants-ages-no-encoding");
	const participantsAgesFromCookieArray = participantsAgesFromCookie
		?.split(",")
		.map(function (age) {
			return parseInt(age);
		});

	return participantsAgesFromCookieArray;
};

export const getAdultsAmount = () => {
	const participantAges = getParticipantAges();
	const adultAges = participantAges.filter((age) => age >= 18);
	const adultsAmount = adultAges.length;
	return adultsAmount;
};

export const getParticipantsAmount = () => {
	const participantAmount = getParticipantAges().length;
	return participantAmount;
};

export const checkIfLocaleIsCSE = (locale) => {
	return locale === "fr_FR_CSE";
};

export const getCurrentLocale = () => {
	const hostname = window.location.hostname;
	switch (hostname) {
		case "www.travelski.com":
			return "fr_FR";
		case "www.nl.travelski.com":
			return "nl_NL";
		case "www.uk.travelski.com":
			return "en_US";
		case "cse.travelski.com":
			return "fr_FR_CSE";
		default:
			console.log("Unknown host");
	}
};

export const checkIfCompanyIsCgos = () => {
	const currentComapny = getCompanyCookie();
	return currentComapny == "cgos";
};

export const isABtest = () => {
	const cookieABtest = getCookie("hidePromoAndCrossPrice");
	const isABtest = cookieABtest ? true : false;
	return isABtest;
};

export const getPreDefinedSeasonDates = () => {
	// Rule: Summer (ETE): 2nd saturday of may AND Winter (Hiver): 1st saturtday of november
	const year = new Date().getFullYear();

	// get the 2nd Saturday of May
	const may = new Date(year, 4, 1);
	const secondSaturday = new Date(
		may.setDate(1 + ((6 - may.getDay() + 7) % 7) + 7)
	);
	const formattedMayDate = `${secondSaturday
		.getDate()
		.toString()
		.padStart(2, "0")}/${(secondSaturday.getMonth() + 1)
		.toString()
		.padStart(2, "0")}/${year}`;

	// get the 1st Saturday of November
	const november = new Date(year, 10, 1);
	const firstSaturday = new Date(
		november.setDate(1 + ((6 - november.getDay() + 7) % 7))
	);
	const formattedNovemberDate = `${firstSaturday
		.getDate()
		.toString()
		.padStart(2, "0")}/${(firstSaturday.getMonth() + 1)
		.toString()
		.padStart(2, "0")}/${year}`;

	console.log(
		`2nd Saturday of May - Begining of the Summer: ${formattedMayDate}`
	);
	console.log(
		`1st Saturday of November - Begining of the Winter: ${formattedNovemberDate}`
	);

	const seasonDates = [];
	seasonDates.beginingOfSummer = formattedMayDate;
	seasonDates.beginingOfWinter = formattedNovemberDate;

	return seasonDates;
};

export const seasonConfigFallBack = () => {
	// It should be call as a fall back, for when no season were secleted, which is a eddge case
	const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	const winter = [];
	const summer = [];

	const seasonsStartDates = getPreDefinedSeasonDates();
	const startSummerMonth = parseInt(
		seasonsStartDates.beginingOfSummer.split("/")[1].split("/")[0]
	);
	const startWinterMonth = parseInt(
		seasonsStartDates.beginingOfWinter.split("/")[1].split("/")[0]
	);

	for (let i = 1; i <= months.length; i++) {
		if (i >= startSummerMonth && i < startWinterMonth) {
			summer.push(i);
		} else {
			winter.push(i);
		}
	}

	return {
		winter: winter,
		summer: summer,
	};
};

export const getSasonBasedOnDate = (date) => {
	const selectedStartDate = formatDate(date);
	const defaultSeasonsDates = getPreDefinedSeasonDates();
	const summerStartDate = formatDate(defaultSeasonsDates.beginingOfSummer);
	const winterStartDate = formatDate(defaultSeasonsDates.beginingOfWinter);
	const isSelectedDateInSummerRange =
		selectedStartDate >= summerStartDate && selectedStartDate < winterStartDate
			? true
			: false;

	if (isSelectedDateInSummerRange) {
		return "E";
	} else {
		return "H";
	}
};

const startOfSummerDateService = (dateStart) => {
	const dateOfBooking = new Date(dateStart);
	const yearOfBooking = dateOfBooking.getFullYear();

	const mayMonthNumber = 4; // months are zero-based in JavaScript, so May is 4
	const firstDayOfMonth = new Date(yearOfBooking, mayMonthNumber, 1);
	const firstSaturday = 7 - firstDayOfMonth.getDay();
	const targetSaturday = firstSaturday + 7;

	const startDateOfSummer = new Date(
		yearOfBooking,
		mayMonthNumber,
		targetSaturday
	);
	return startDateOfSummer;
};

const startOfWinterDateService = (dateStart) => {
	const dateOfBooking = new Date(dateStart);
	const yearOfBooking = dateOfBooking.getFullYear();

	const novemberMonthNumber = 10; // months are zero-based in JavaScript, so November is 10
	const firstDayOfMonth = new Date(yearOfBooking, novemberMonthNumber, 1);
	const firstSaturday = 7 - firstDayOfMonth.getDay();
	const startDateOfWinter = new Date(
		yearOfBooking,
		novemberMonthNumber,
		firstSaturday
	);

	return startDateOfWinter;
};

export const checkIsSummerBookingService = (dateStart) => {
	const startDateOfSummer = startOfSummerDateService(dateStart);
	const startDateOfWinter = startOfWinterDateService(dateStart);

	const dateOfBooking = new Date(dateStart);
	// If the date of the booking is bigger or the same and as the summer dates, and before the start of the winter, it is a summer booking
	if (dateOfBooking >= startDateOfSummer && dateOfBooking < startDateOfWinter) {
		return true;
	}
};

// Winter season starts 1st Saturday of November
export const checkIsWinterBookingService = (dateStart) => {
	const startDateOfSummer = startOfSummerDateService(dateStart);
	const startDateOfWinter = startOfWinterDateService(dateStart);
	const dateOfBooking = new Date(dateStart);
	// If the date of the booking is before the start of the winter, and before the start of the summer season, the booking is still a winter season booking
	// If the date of booking is more then the startDateOfWinter then it's still a winter season booking
	if (
		(dateOfBooking <= startDateOfWinter && dateOfBooking < startDateOfSummer) ||
		dateOfBooking >= startDateOfWinter
	) {
		return true;
	}
};

export const checkIsSummerOrWinter = (dateStart) => {
	if (!dateStart)
		throw new Error("dateStart is mandatory in checkIsSummerOrWinter");
	const isSummer = checkIsSummerBookingService(dateStart);
	const isWinter = checkIsWinterBookingService(dateStart);
	if (isSummer) {
		return "E";
	} else if (isWinter) {
		return "H";
	}
};

export const formatDate = (date) => {
	const day = date.split("/")[0];
	const month = date.split("/")[1];
	const year = date.split("/")[2];
	return `${year + "-" + month + "-" + day}`;
};
